import { EntityWithCosts } from "./Entity";

export class Supplier extends EntityWithCosts {
    password?: string;
    confirmPassword?: string;
}
